import { formatUserFacingError } from '@/lib/errors'
import { useState, useEffect } from 'react'
import type { ApplicationDocument } from '@/types'
import { applicationsService } from '../services/applications.service'

interface UseApplicationsResult {
  applications: Array<ApplicationDocument & { id: string }>
  loading: boolean
  error: string | null
}

export function useApplications(): UseApplicationsResult {
  const [applications, setApplications] = useState<Array<ApplicationDocument & { id: string }>>([])
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState<string | null>(null)

  useEffect(() => {
    applicationsService
      .getPublished()
      .then(setApplications)
      .catch((err) => setError(formatUserFacingError(err, 'Failed to load applications')))
      .finally(() => setLoading(false))
  }, [])

  return { applications, loading, error }
}
